import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome to Baraka Inn admin");
      const landing = user?.role === "receptionist" ? "/admin/bookings" : "/admin/dashboard";
      navigate(landing);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative overflow-hidden">
        <img src="https://images.pexels.com/photos/3011575/pexels-photo-3011575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000" alt="Baraka Inn" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--deep)] to-[color:var(--deep)]/20" />
        <div className="absolute bottom-12 left-12 text-white">
          <p className="font-ui uppercase tracking-[0.3em] text-xs text-[color:var(--gold)]">Team Portal</p>
          <h1 className="font-heading text-5xl mt-3">Baraka Inn</h1>
          <p className="font-body mt-3 text-white/80 max-w-md">Manage bookings, check-ins and revenue with care.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 sm:px-12 bg-[color:var(--sand)]">
        <form onSubmit={submit} className="w-full max-w-md bg-white p-8 sm:p-10 rounded-3xl border border-[color:var(--brand)]/10 shadow-sm" data-testid="admin-login-form">
          <div className="w-11 h-11 rounded-xl bg-[color:var(--brand)] flex items-center justify-center text-white mb-6">
            <Lock className="w-5 h-5" />
          </div>
          <h2 className="font-heading text-3xl text-[color:var(--deep)]">Team sign-in</h2>
          <p className="font-body text-sm text-[color:var(--muted-text)] mt-2">Enter your credentials to continue.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label>Email</Label>
              <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="admin@barakainn.co.tz" className="mt-1" />
            </div>
            <div>
              <Label>Password</Label>
              <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••" className="mt-1" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid="login-submit" className="mt-8 w-full h-11 rounded-full bg-[color:var(--brand)] hover:bg-[color:var(--brand-dark)] text-white font-ui">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
          <Link to="/" className="mt-6 block text-center text-xs font-ui text-[color:var(--muted-text)] hover:text-[color:var(--brand)]">
            ← Back to the public site
          </Link>
        </form>
      </div>
    </div>
  );
}
